import { Icon } from '@design';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './EmptyState.module.scss';

export const EmptyState = () => {
  const { t } = useTranslation(['earnings']);

  return (
    <div className={styles.root}>
      <Icon iconName="AutomaticRefinement" size={80} viewBox="0 0 60 60" />
      <div className={styles.title}>
        {t('earnings:earningsInsight.drawer.alfredIsAnalyzing')}
      </div>
      <div className={styles.description}>
        {t('earnings:earningsInsight.drawer.checkBackSoon')}
      </div>
    </div>
  );
};
